import React, {useState} from "react";

import {i18n} from "translate/i18n";

import {useNavigate, useParams} from "react-router";
import {Form, Field, Formik} from "formik";

import {SelectTags} from "components/Select";
import Editor from "components/Editor";
import Loading from "components/Loading";

import {useTags} from "store/providers/tags";

import {useQuery} from "react-query";

import {toast} from "react-toastify";
import {getGoal, setGoal} from "services/Goals.service";
import {swalQuestion} from "components/Swal";
import {useUser} from "../../../store/providers/app";
import {Tooltip} from "../../../components/Tooltip";

import Steps from "../../../components/Steps";

const INITIAL_VALUES = {
    status: '',
    codigo: '',
    titulo: '',
    contexto: '',
    baseline: '',
    progress: '',
    notas_de_rodape: '',
    informacoes_complementares: ''
}

const FormMetas = () => {

    let {id} = useParams();
    const {user, username} = useUser();

    const {tags, includeTags, handleChange} = useTags();
    const navigate = useNavigate();

    const [formValues, setFormValues] = useState(INITIAL_VALUES);

    const {isFetching} = useQuery(['indicator', id],
        () => {
            return getGoal(id)
        }, {
            onSuccess: (res) => {

                const response = res.data.data

                setFormValues({
                    id: response.id,
                    status: response.status,
                    codigo: response.codigo,
                    titulo_meta: response.titulo_meta,
                    subtitulo_meta: response.subtitulo_meta,
                    contexto: response.contexto,
                    escopo: response.escopo,
                    ambicao: response.ambicao,
                    baseline: response.baseline  ?? '',
                    progress: response.progress ?? '',
                    notas_de_rodape: response.notas_de_rodape,
                    o_que_faremos_2022: response.o_que_faremos_2022,
                    resultados_2021: response.resultados_2021,
                });

                includeTags(response.tags)
               // changeDefault({value: response.id, label: response.titulo_meta, status: response.status});

            },
            onError: (error) => {
                toast.error(i18n.t('error.notFoundIndicator'));
                navigate('/workflow')
            },
            retry: 2,
            refetchOnWindowFocus: false,
            retryOnMount: false
        })

    const View = ({label, children}) => {
        return (
            <div className="form-group">
                <label className="form-label">{label}</label>
                {children}
            </div>
        )
    }

    function changeArray(item) {
        return item.map(i => ({id: i.value, name: i.label}))
    }


    const ViewSelect = ({label, children, name, selected}) => {

        return (
            <div className="form-group mt-2">
                <label className="form-label">{label}</label>
                <SelectTags
                    items={tags.tagsList[name]}
                    selected={selected}
                    handleChange={handleChange}
                    name={name}
                />

                {children}
            </div>
        )
    }

    if (user.profile !== 1) {
        toast.error('Você não tem permissão para ver este indicador!')
        navigate('/')
    }

    if (isFetching) return <div className="px-3 py-3"><Loading/></div>

    return (
        <>
            <Formik
                initialValues={formValues}
                enableReinitialize
                onSubmit={async (values) => {

                    const newTemas = changeArray(tags.temas_materiais)
                    const newOds = changeArray(tags.ods)

                    values['o_que_faremos_2022'] = values['o_que_faremos_2022'].replaceAll(';', '');

                    let newData = {...values, username, tags: {temas_materiais: newTemas, ods: newOds}}

                    swalQuestion(`${i18n.t('questions.editGoal')} <b>${values.titulo_meta}</b>?`).then((result) => {
                        if (result.isConfirmed) {
                            setGoal(id, newData)
                                .then(() => toast.success(i18n.t('success.editSuccessGoal')))
                                .catch((err) => toast.error(i18n.t('error.badRequest')))
                        }
                    })

                }}
            >
                {({
                      values,
                      setFieldValue,
                  }) => (

                    <Form>

                        <div className="pt-4 px-3 d-grid gap-3">
                            <div className="row gap-2 text-sm">
                                <div className="col align-self-end">
                                    <Steps statusIndicator={formValues.status} param="goal" />
                                </div>
                            </div>
                        </div>

                        <div className="p-3">
                            <View label={i18n.t('label.metaTitle')}>
                                <div className="input-group">
                                    <Tooltip label="Código">
                                     <span className="input-group-text">
                                        {values.codigo}
                                    </span>
                                    </Tooltip>
                                    <Field
                                        className="form-control"
                                        name="titulo_meta"
                                    />
                                </div>
                            </View>

                            <View label={i18n.t('label.metaSubtitle')}>
                                <Field
                                    className="form-control"
                                    name="subtitulo_meta"
                                />
                            </View>

                            <div className="form-group">
                                <label className="form-label">{i18n.t('stage.context')}</label>
                                <Editor
                                    handleChange={setFieldValue}
                                    data={values.contexto}
                                    name="contexto"
                                />
                            </div>

                            <div className="form-group">
                                <label className="form-label">{i18n.t('label.scope')}</label>
                                <Editor
                                    handleChange={setFieldValue}
                                    data={values.escopo}
                                    name="escopo"
                                />
                            </div>

                            <div className="form-group">
                                <label className="form-label">{i18n.t('label.ambition')}</label>
                                <Editor
                                    handleChange={setFieldValue}
                                    data={values.ambicao}
                                    name="ambicao"
                                />
                            </div>

                            <div className="form-group">
                                <label className="form-label">Resultados 2025</label>
                                <Editor
                                    handleChange={setFieldValue}
                                    data={values.resultados_2021}
                                    name="resultados_2021"
                                />
                            </div>

                            <div className="form-group">
                                <label className="form-label">O que faremos 2026</label>
                                <Editor
                                    handleChange={setFieldValue}
                                    data={values.o_que_faremos_2022}
                                    name="o_que_faremos_2022"
                                />
                            </div>

                            <div className="row">
                                <div className="col">
                                    <div className="form-group">
                                        <label className="form-label">Baseline</label>
                                        <Field
                                            className="form-control"
                                            name="baseline"
                                        />
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="form-group">
                                        <label className="form-label">{i18n.t("label.ourProgress")}</label>
                                        <Field
                                            className="form-control"
                                            name="progress"
                                        />
                                    </div>
                                </div>
                            </div>

                            <h5 className="my-3">{i18n.t('stage.tags')}</h5>

                            <ViewSelect label="Temas Materiais" name="tags.temas_materiais"
                                        selected={tags.temas_materiais}/>

                            <ViewSelect label="ODS" name="ods" selected={tags.ods} values={values.ods}>
                                <div className="d-flex flex-wrap gap-2 mt-3">
                                    {tags.ods.map(item =>
                                        <img
                                            key={item.label}
                                            src={window.location.origin + `/assets/img/certificados/ODS_${item.label}.png`}
                                            alt={`ODS_${item.label}`}
                                            width={60}/>
                                    )}
                                </div>
                            </ViewSelect>

                            <div className="form-group">
                                <label className="form-label">{i18n.t('stage.footer')}</label>
                                <Editor handleChange={setFieldValue}
                                        data={values.notas_de_rodape}
                                        name="notas_de_rodape"/>
                            </div>

                        </div>

                        <hr className="p-0"/>
                        <div className="float-end pb-3 pe-3">
                            <button className="btn btn-success px-5 py-2"
                                    type="submit">{i18n.t('buttons.save')}</button>
                        </div>

                    </Form>
                )}
            </Formik>
        </>
    )
}

export default FormMetas
